import { format, parseISO, isValid } from "date-fns";

export const formatToUSDate = (dateValue) => {
  if (!dateValue) return "-";

  let dateObj = parseISO(dateValue);

  if (!isValid(dateObj)) dateObj = new Date(dateValue);

  if (!isValid(dateObj)) return "-";

  return format(dateObj, "MM/dd/yyyy");
};

export const formatToUSDateTime = (dateValue) => {
  if (!dateValue) return "-";

  let dateObj = parseISO(dateValue);

  if (!isValid(dateObj)) dateObj = new Date(dateValue);
  if (!isValid(dateObj)) return "-";

  // Detect if the time is exactly midnight (00:00:00)
  const isMidnight =
    dateObj.getUTCHours() === 0 &&
    dateObj.getUTCMinutes() === 0 &&
    dateObj.getUTCSeconds() === 0;

  // If midnight, return only date
  if (isMidnight) {
    return format(dateObj, "MM/dd/yyyy");
  }

  // Otherwise include time
  return format(dateObj, "MM/dd/yyyy hh:mm a");
};

export const formatToDate = (dateValue) => {
  if (!dateValue) return "-";
  let dateObj = parseISO(dateValue);
  if (!isValid(dateObj)) dateObj = new Date(dateValue);
  if (!isValid(dateObj)) return "-";
  return format(dateObj, "dd");
};

export const formatToMonth = (dateValue) => {
  if (!dateValue) return "-";
  let dateObj = parseISO(dateValue);
  if (!isValid(dateObj)) dateObj = new Date(dateValue);
  if (!isValid(dateObj)) return "-";
  return format(dateObj, "MMM");
};

export const formatToYear = (dateValue) => {
  if (!dateValue) return "-";
  let dateObj = parseISO(dateValue);
  if (!isValid(dateObj)) dateObj = new Date(dateValue);
  if (!isValid(dateObj)) return "-";
  return format(dateObj, "yyyy");
};

export const calculateCountdown = (startDate) => {
  const now = new Date();
  const eventDate = new Date(startDate);

  if (isNaN(eventDate.getTime())) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  const diff = eventDate - now;

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  return {
    days: days >= 0 ? days : 0,
    hours: hours >= 0 ? hours : 0,
    minutes: minutes >= 0 ? minutes : 0,
    seconds: seconds >= 0 ? seconds : 0,
  };
};
